var _defs, _circle, _use, _use2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasicIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.239215686 0 0 0 0 0.254901961 0 0 0 0 0.356862745 0 0 0 1 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.9026726 0 0 0 0 0.83054497 0 0 0 0.775213068 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.760784314 0 0 0 0 0.807843137 0 0 0 0 0.850980392 0 0 0 0.305233829 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__g"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.242461252 0 0 0 0 0.298645712 0 0 0 0 0.334578804 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.04l-2.593 8.35a1.047 1.047 0 01-1 .736H5.782c-.472 0-.886-.316-1.01-.772l-2.28-8.35A2.098 2.098 0 010 5.82c0-1.158.94-2.096 2.1-2.096a2.098 2.098 0 011.967 2.83 8.081 8.081 0 005.441-2.612A2.094 2.094 0 0110.5 0z",
    id: "basic_icon_svg_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.99 8.597l-3.357 5.153a.2.2 0 01-.149.08h-.788a.152.152 0 01-.13-.088L7.47 8.605c-.02-.048.007-.089.06-.089H9.93c.052 0 .076.039.05.084l-.341.502a.228.228 0 00-.011.173l.709 1.839c.019.048.058.053.086.008l1.64-2.525a.199.199 0 01.148-.08h1.734c.053-.001.073.035.045.08z",
    id: "basic_icon_svg_svg__f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.53%",
    y1: "28.861%",
    x2: "71.636%",
    y2: "82.766%",
    id: "basic_icon_svg_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1F7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D5E2",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#688097",
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#basic_icon_svg_svg__a)",
    transform: "translate(5.5 7.5)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#basic_icon_svg_svg__b)",
    xlinkHref: "#basic_icon_svg_svg__c"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#basic_icon_svg_svg__d)",
    xlinkHref: "#basic_icon_svg_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.04l-2.593 8.35a1.047 1.047 0 01-1 .736l-4.767-.001V0z",
    fillOpacity: 0.5,
    fill: "#C4CFDB",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#basic_icon_svg_svg__e)",
    xlinkHref: "#basic_icon_svg_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8BAAC7",
    xlinkHref: "#basic_icon_svg_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#basic_icon_svg_svg__g)",
    xlinkHref: "#basic_icon_svg_svg__f"
  }))))));
}

export default SvgBasicIconSvg;